var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeBlueEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5831 0H2.58315C1.48315 0 0.583145 0.9 0.583145 2V14C0.583145 15.1 1.48315 16 2.58315 16H11.5831V14H2.58315V4L9.52314 8.34C10.1731 8.75 10.9931 8.75 11.6431 8.34L18.5831 4V9H20.5831V2C20.5831 0.9 19.6831 0 18.5831 0ZM10.5831 7L2.58315 2H18.5831L10.5831 7ZM18.4331 11.86C18.1231 11.54 17.5831 11.76 17.5831 12.21V14H14.5831C14.0331 14 13.5831 14.45 13.5831 15C13.5831 15.55 14.0331 16 14.5831 16H17.5831V17.79C17.5831 18.24 18.1231 18.46 18.4331 18.15L21.2231 15.36C21.4231 15.16 21.4231 14.85 21.2231 14.65L18.4331 11.86Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeBlueEmail);
export default __webpack_public_path__ + "static/media/ShapeBlueEmail.56b80ba557e6e8844d808bb660117845.svg";
export { ForwardRef as ReactComponent };